export default __webpack_public_path__ + "static/media/iread_22_5.40f8096d.jpg";